// @flow

import { Action, ConditionName } from './type'

export type AppAction = Action & {
  type: 'TOGGLE_SELECTOR' | 'TOGGLE_CONDITION'
}

export const TOGGLE_SELECTOR = 'TOGGLE_SELECTOR'
export function toggleSelector() {
  return { type: TOGGLE_SELECTOR }
}

export const TOGGLE_CONDITION = 'TOGGLE_CONDITION'
export function toggleCondition(name: ConditionName) {
  return { type: TOGGLE_CONDITION, payload: name }
}
